import { supabase } from "../../Services/supabaseClient";
import { generateQuotePdfDocument } from "../utils/generateQuotePdf";

const arrayBufferToBase64 = (arrayBuffer) => {
  let binary = "";
  const bytes = new Uint8Array(arrayBuffer);
  const length = bytes.byteLength;

  for (let index = 0; index < length; index += 1) {
    binary += String.fromCharCode(bytes[index]);
  }

  return window.btoa(binary);
};

export const sendQuoteEmail = async ({
  companyId,
  quoteId,
  quote,
  items,
  to,
  subject,
  body,
  userId,
}) => {
  const doc = await generateQuotePdfDocument({ quote, items });
  const pdfArrayBuffer = doc.output("arraybuffer");
  const pdfBase64 = arrayBufferToBase64(pdfArrayBuffer);

  const { data: functionData, error: functionError } =
    await supabase.functions.invoke("send-quote-email", {
      body: {
        to,
        subject,
        body,
        pdfBase64,
        fileName: `${quote.quote_number || "quote"}.pdf`,
      },
    });

  if (functionError) {
    throw functionError;
  }

  if (functionData?.error) {
    throw new Error(functionData.error);
  }

  const { data, error } = await supabase
    .from("crm_quotes")
    .update({
      recipient_email: to,
      email_subject: subject,
      email_body: body,
      email_status: "sent",
      email_error: null,
      email_sent_by: userId,
      status: "sent",
      sent_at: new Date().toISOString(),
    })
    .eq("company_id", companyId)
    .eq("id", quoteId)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};

export const markQuoteEmailFailed = async ({
  companyId,
  quoteId,
  to,
  subject,
  body,
  errorMessage,
}) => {
  const { data, error } = await supabase
    .from("crm_quotes")
    .update({
      recipient_email: to || null,
      email_subject: subject || null,
      email_body: body || null,
      email_status: "failed",
      email_error: errorMessage || "Unknown email error",
    })
    .eq("company_id", companyId)
    .eq("id", quoteId)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};
